import React from "react"
import Hero from "../../features/home/header/Hero"
import OptionCards from "../../features/home/optionCards/OptionCards"
import "./HomePage.css"

export default function Home(){
    return(
        <div className="home-main-container"> 
            <Hero/>
            <OptionCards/>
        </div>
    )
}